var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-item"},[_c('div',{staticClass:"label",class:{'label-require':_vm.attr.required}},[_vm._v(" "+_vm._s(_vm.attr.title))]),_c('van-field',{attrs:{"name":_vm.attr.name,"placeholder":_vm.attr.description,"rules":[
          {
            required: _vm.attr.required ,
            validator: _vm.attr.required ? _vm.Validator : null,
            message: _vm.attr.message,
          } ]},model:{value:(_vm.valu),callback:function ($$v) {_vm.valu=$$v},expression:"valu"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }